export class EditPbaErrorResponse {
  name: any;
}
